import { useState } from "react";

import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

export type Props = {
  isOpen: boolean;
  closeModal: () => void;
  mixToUnAdoptModalId: number | null | undefined;
  handleConfirmUnAdoptBudgetMix: (mixId: number) => Promise<void>;
};

export const UnadoptBudgetMixModal = ({
  isOpen,
  closeModal,
  mixToUnAdoptModalId,
  handleConfirmUnAdoptBudgetMix,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      titleContent={
        <span className="block font-semibold text-xl">Unadopt budget?</span>
      }
    >
      <div className="flex flex-col justify-between items-start h-[100px]">
        <div className="flex flex-col gap-4 justify-start items-start">
          <span className="block text-xs text-gray+1">
            You can re-add this budget back if you need to later.
          </span>
        </div>
        <div className="flex justify-end items-center w-full gap-2">
          <TertiaryButton
            disabled={isLoading}
            loading={isLoading}
            onClick={closeModal}
          >
            CANCEL
          </TertiaryButton>
          <PrimaryButton
            disabled={isLoading}
            loading={isLoading}
            onClick={async () => {
              if (mixToUnAdoptModalId) {
                setIsLoading(true);
                await handleConfirmUnAdoptBudgetMix(mixToUnAdoptModalId);
                setIsLoading(false);
              }
            }}
          >
            YES, CONTINUE
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};
